module.exports = __webpack_public_path__ + "static/media/IMG_1821-min.2407bb4a.jpg";